import React from 'react';
import _ from 'lodash';
import linkifyStr from 'linkifyjs/string';
import parse from 'html-react-parser';

const PLACEHOLDERS = {
  id: '__id__',
  display: '__display__',
};

const escapeRegex = (str: string) => str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

const markupToRegex = _.memoize((markup: string) => {
  const escapedMarkup = escapeRegex(markup);
  const charAfterDisplay =
    markup[markup.indexOf(PLACEHOLDERS.display) + PLACEHOLDERS.display.length];
  const charAfterId = markup[markup.indexOf(PLACEHOLDERS.id) + PLACEHOLDERS.id.length];
  return new RegExp(
    escapedMarkup
      .replace(PLACEHOLDERS.display, `([^${escapeRegex(charAfterDisplay || '')}]+?)`)
      .replace(PLACEHOLDERS.id, `([^${escapeRegex(charAfterId || '')}]+?)`)
  );
});

const MessageText = ({ text }: { text: string }) => {
  const content = text.split(' ').map((word) => {
    const reg = markupToRegex('@[__display__](__id__)');
    const [a, display, id] = reg.exec(word) || [];
    if (display) {
      return (
        <>
          <span className='at-mention-name'>{`@${display}`}</span>
          <span> </span>
        </>
      );
    }
    return (
      <span>
        {parse(
          linkifyStr(word, {
            defaultProtocol: 'https',
            className: 'message-link',
            tagName: 'a',
            target: {
              url: '_blank',
              email: null,
            },
          })
        )}{' '}
      </span>
    );
  });

  return <>{content}</>;
};

export default MessageText;
